// extracted by extract-css-chunks-webpack-plugin
module.exports = {"product_flags":"productFlag__product_flags","flag":"productFlag__flag","flag_content":"productFlag__flag_content"};